import { buildVideoStreamUrl } from '../media-server';
import { resolveClipUrl } from './resolve-clip-url';

interface IClipPlaybackPaths {
  verticalPath?: string | null;
  basePath?: string | null;
  verticalLocalPath?: string | null;
  baseLocalPath?: string | null;
}

export function resolveClipPlaybackUrl(paths: IClipPlaybackPaths): string | null {
  const r2 = resolveClipUrl(paths.verticalPath ?? null) ?? resolveClipUrl(paths.basePath ?? null);
  if (r2) {
    return r2;
  }
  const local = paths.verticalLocalPath ?? paths.baseLocalPath ?? null;
  return local ? buildVideoStreamUrl(local) : null;
}
